<template>
  <div class="task-report">
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
    >
      <el-tab-pane
        label="任务报告"
        name="first"
      >
        <!-- 任务报告总计数 -->
        <div class="now">
          <span></span>
          <span>实时</span>
        </div>
        <task-card :liList=liList></task-card>
        <!-- 周报月报 -->
        <div class="weekReport">
          <div class="week">
            <el-button
              :type="weekType == '1'?'primary':'info'"
              @click="weekend"
            >周报</el-button>
            <el-button
              :type="weekType != '1'?'primary':'info'"
              @click="mounthed"
            >月报</el-button>
          </div>
          <task-card :liList=weekliList></task-card>
        </div>

        <!-- 订单统计 -->

        <div class="now">
          <span></span>
          <span>订单统计</span>
        </div>

        <filter-panel
          :data="groups"
          @search="filterChange"
        ></filter-panel>
        <data-list
          :data="data"
          :columns="columns"
          :page="page"
          :page-size="page.pageSize"
          @page-size-changed="pageSizeChanged"
          @page-changed="pageChanged"
          @sort-change="sortChange"
        ></data-list>
      </el-tab-pane>

      <el-tab-pane
        label="人员报告"
        name="second"
      >
        <!-- 人员统计当前进度 -->
        <div class="now">
          <span></span>
          <span>当前进度</span>
        </div>
        <data-list
          :table-style='{name:"mixture"}'
          :data="dataOne"
          :columns="columns1"
        ></data-list>

        <!-- 周报月报 -->
        <div class="weekReport">
          <div class="week">
            <el-button
              :type="mouthType == '1'?'primary':'info'"
              @click="week"
            >周报</el-button>
            <el-button
              :type="mouthType != '1'?'primary':'info'"
              @click="mouth"
            >月报</el-button>
          </div>
        </div>
        <data-list
          :table-style='{name:"mixture"}'
          :data="dataTwo"
          :columns="columns2"
        ></data-list>

      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import task from "@/backend/services/task/task.js";
import taskCard from "../../../components/taskStatisticCard/taskCard.vue";
import api from "@/backend/apiConfig/apiConfig";
import listPageCreate from "@/mixins/listPageCreate";
import filterPanel from "@/components/iglobalwin/filterPanelNew/filterPanel";
import customer from "@/backend/services/account/customer";

var _that;
const page = listPageCreate({
  //订单统计
  searchConfig: {
    api: api.task.getOrder,
    method: "POST"
  }
});
export default {
  components: {
    taskCard,
    filterPanel
  },
  mixins: [page],
  data() {
    const columns = [
      {
        label: "订单编号",
        bind: "orderCode"
      },
      {
        label: "客户名称",
        bind: "customerName"
      },

      {
        label: "创建日期",
        bind: "createTime",
        options: [
          {
            label: "由高到低",
            value: "desc"
          },
          {
            label: "由低到高",
            value: "asc"
          }
        ],
        sort: "createTime"
      },
      {
        label: "套餐类型",
        bind: "packageName"
      },
      {
        label: "销售人员",
        bind: "salesStaffName"
      },
      {
        label: "订单进度",
        type: "progressItem"
      }
    ];
    const columns1 = [
      {
        label: "处理人",
        bind: "appointorName"
      },
      {
        label: "未开始",
        bind: "toStartCount"
      },
      {
        label: "进行中",
        bind: "inProgressCount"
      },
      {
        label: "本周已完成",
        bind: "weekFinishedCount"
      },
      {
        label: "总计完成",
        bind: "finishedCount"
      },
      {
        label: "已延期",
        bind: "hasBeenPostponedCount"
      }
    ];
    const columns2 = [
      {
        label: "处理人",
        bind: "appointorName"
      },
      {
        label: "未开始",
        bind: "toStartCount"
      },
      {
        label: "进行中",
        bind: "inProgressCount"
      },
      {
        label: "新增",
        bind: "newCount"
      },
      {
        label: "已完成",
        bind: "finishedCount"
      },
      {
        label: "已延期",
        bind: "hasBeenPostponedCount"
      },
      {
        label: "完成率",
        bind: "finishedRate"
      },
      {
        label: "延期率",
        bind: "hasBeenPostponedRate"
      }
    ];
    return {
      columns: columns,
      columns1: columns1,
      columns2: columns2,
      activeName: "first",
      totalNum: "",
      dataOne: [],
      dataTwo: [],
      liList: [],
      weekliList: [],
      weekType: "1",
      mouthType: "1",
      groups: {
        multiples: [
          {
            placeholder: "套餐类型",
            defaultText: "套餐类型",
            label: "套餐类型",
            options: [],
            prop: "packageId",
            props: {
              label: 'packageName',
              value: 'id'
            },
            multiple: true,
            value: []
          }
        ],
        others: [
          {
            tagName: "sky-date-picker",
            type: "daterange",
            label: "日期范围",
            startPlaceholder: "开始日期",
            endPlaceholder: "结束日期",
            prop: ["startDate", "endDate"],
            value: []
          }
        ]
      }
    };
  },
  methods: {
    handleClick(tab) {
      if (tab.name == "second") {
        this.getStaff(0);
        this.getStaff(1);
      }
    },
    async getStatistics(value, isWeek) {
      let data = await task.getStatistics({ type: value });
      this.totalNum = data.data;
      if (isWeek == "3" || isWeek == "4") {
        this.weekliList = [
          {
            title: "已完成",
            total: _that.totalNum.finishedCount,
            finished: _that.totalNum.finishedRate
          },
          {
            title: "已延期",
            total: _that.totalNum.hasBeenPostponedCount,
            delaied: _that.totalNum.hasBeenPostponedRate
          },
          {
            title: "新增",
            total: _that.totalNum.newCount
          }
        ];
      } else {
        this.liList = [
          {
            title: "本周已完成",
            total: _that.totalNum.weekFinishedCount,
            finishedAll: _that.totalNum.finishedCount
          },
          {
            title: "本周已延期",
            total: _that.totalNum.weekHasBeenPostponedCount,
            finishedAll: _that.totalNum.hasBeenPostponedCount
          },
          {
            title: "未开始",
            total: _that.totalNum.toStartCount
          },
          {
            title: "进行中",
            total: _that.totalNum.inProgressCount
          }
        ];
      }
    },
    async getStaff(value) {
      let data = await task.getStaff({ type: value });
      if (value == "1" || value == "2") {
        this.dataTwo = data.data;
      }
      this.dataOne = data.data;
    },
    async mouthStaff() {
      let data = await task.getStaff({ type: 2 });
      this.dataTwo = data.data;
    },
    weekend() {
      //任务统计周报
      this.weekType = "1";
      this.getStatistics(3, 3);
    },
    mounthed() {
      //任务统计月报
      this.weekType = "2";
      this.getStatistics(4, 4);
    },
    week() {
      //人员统计周报
      this.mouthType = "1";
      this.getStaff(1);
    },
    mouth() {
      //人员统计月报
      this.mouthType = "2";
      this.mouthStaff();
    },
    async getorderPackageList() {
      let res = await customer.getPackagedropdownlist();
      this.groups.multiples[0].options = res.data
    }
  },
  mounted() {
    _that = this;
    this.query();
    this.getStatistics(0);
    this.getStatistics(3, 3);
    this.getorderPackageList()
  }
};
</script>

<style scoped lang="scss">
.weekReport {
  margin-top: 40px;
  margin-bottom: 20px;
  .week {
    margin-bottom: 20px;
  }
}
.now {
  padding: 7px;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  :first-child {
    display: inline-block;
    width: 7px;
    height: 20px;
    border-radius: 20px;
    background: #66b1ff;
    margin-right: 10px;
  }
}
</style>
